import { useEffect } from "react";
import { useLocation } from "react-router";

export const useLocationUpdate = () => {
  const location = useLocation();

  useEffect(() => {
    if (!location) return;

    if ((window as any).ga) {
      (window as any).ga("set", "page", location.pathname);
      (window as any).ga("send", "pageview");
    }
    if ((window as any)._hsq) {
      (window as any)._hsq.push(["setPath", location.pathname]);
      window._hsq.push(["trackPageView", {}]);
    }
  }, [location?.pathname]);
};
